import Services from "./index";
import { connect } from "react-redux";
import React, { Component } from "react";
import { bindActionCreators } from "redux";
import { ReactTitle } from "react-meta-tags";
import { withRouter } from "react-router-dom";
import Modal from "../../../utils/customModal";
import { getRoles } from "../../../../Redux/reducer/session";
import * as ClientActions from "../../../../Redux/actions/clientActions";
import {
  loadingHtml,
} from "../../../utils/functions";

//PROPIETARIO o UNIFICADO
const permissions = {
  'MOD_FORMAT_TYPE': [
    { value: 'PROPIETARIO', label: 'Propietario'},
    { value: 'UNIFICADO', label: 'Unificado'},
  ],
  'default': [
    { value: 0, label: '0'},
    { value: 1, label: '1'},
    { value: 2, label: '2'},
    { value: 3, label: '3'},
  ],
  noApprovals: ['MOD_INVITATION_PROV', 'MOD_LOG']
};

export class InstitutionServices extends Component {
  constructor(props) {
    super(props);
    this.state = {
      modal: {
        show: false,
        content: null,
        onClose: undefined,
      },
      contentReady: false,
      modulo: []
    };
  }

  componentDidMount() {
    return this.getModules();
  }

  componentWillUnmount() {
    this.setState({ contentReady: false, modulo: [] });
  }

  getModules = () => {
    const { actions: { getClientModules } } = this.props;
    const { modal } = this.state;
    modal.show = true;
    modal.content = loadingHtml();

    this.setState({ modal });

    return getClientModules(this.props.clientRedu.id)
      .then((response) => {
        modal.show = false;
        modal.content = null;
        const modulo = response?.data?.filter(mod => mod?.module?.id !== 10)
        this.setState({ modulo, contentReady: true, modal });
      })
      .catch(() => {
        modal.show = false;
        modal.content = null;
        this.setState({ contentReady: false, modal });
      });
  }

  render() {
    const { modulo, contentReady, modal } = this.state;
    const { roles } = this.props;

    const institutionId = parseInt(this.props.clientRedu.id, 10);

    return (
      <React.Fragment>
        <ReactTitle title={`Gestión de Clientes - Servicios`} />
        {contentReady && (
          <Services 
            modulo={modulo}
            roles={roles}
            createUrl={`security/modules/institution/${institutionId}`} 
            createMethod={`put`}
            permissions={permissions}
            getModules={this.getModules} />
        )}
        <Modal
          key={`provider-users`}
          show={modal.show}
          handleClose={modal.onClose}
        >
          {modal.content}
        </Modal>
      </React.Fragment>
    );
  }
}

export const mapStateToProps = (state) => {
  return {
    roles: getRoles(state),
    clientRedu: state.clientReducer.institution,
  };
};

export const mapDispatch = (dispatch) => {
  return {
    actions: bindActionCreators(ClientActions, dispatch),
  };
};

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatch
  )(InstitutionServices)
);
